import React from 'react';
import FFLink from '../FFLink';
import styles from './DropdownTextLinkItem.module.css';

/**
 *
 * @param {object} props
 * @param {FF.HeaderNavTextItem} props.navItem
 */
export default function DropdownTextItem({ navItem }) {
  return (
    <li className={styles.wrapper}>
      <FFLink className={styles.textLink} url={navItem.url}>
        {navItem.label}
      </FFLink>
    </li>
  );
}
